import { REVIEW_TYPE } from "@apps/reviews/constants";

import { REVIEWS_FORM_STEPS_NAMES } from "../../constants";

export const checkIsMobile = () => {
    return window.innerWidth <= 600;
};

export const isShowNavProgress = (params: {
    currentStepName: REVIEWS_FORM_STEPS_NAMES;
    isAuthenticated: boolean;
    isAddedImages: boolean;
}) => {
    const { currentStepName, isAuthenticated, isAddedImages } = params;
    const isMobile = checkIsMobile();

    if (isMobile) {
        return (
            currentStepName === REVIEWS_FORM_STEPS_NAMES.MEDIA &&
            !isAuthenticated &&
            !isAddedImages
        );
    }

    if (
        [
            REVIEWS_FORM_STEPS_NAMES.RATING,
            REVIEWS_FORM_STEPS_NAMES.RESULT,
        ].includes(currentStepName)
    ) {
        return false;
    }

    return true;
};

export const getNavProgressSteps = (params: {
    reviewType: REVIEW_TYPE | undefined;
    hasCustomForms: boolean;
    isAuthenticated: boolean;
    isReviewsMediaEnabled: boolean;
}) => {
    const {
        reviewType,
        hasCustomForms,
        isAuthenticated,
        isReviewsMediaEnabled,
    } = params;

    let navProgressSteps;

    if (hasCustomForms && reviewType === REVIEW_TYPE.PRODUCT_REVIEW) {
        navProgressSteps = [
            REVIEWS_FORM_STEPS_NAMES.RATING,
            REVIEWS_FORM_STEPS_NAMES.REVIEW,
            REVIEWS_FORM_STEPS_NAMES.ATTRIBUTES,
        ];
    } else {
        navProgressSteps = [
            REVIEWS_FORM_STEPS_NAMES.RATING,
            REVIEWS_FORM_STEPS_NAMES.REVIEW,
        ];
    }

    if (isReviewsMediaEnabled) {
        navProgressSteps = [
            ...navProgressSteps,
            REVIEWS_FORM_STEPS_NAMES.MEDIA,
        ];
    }

    if (!isAuthenticated) {
        navProgressSteps = [
            ...navProgressSteps,
            REVIEWS_FORM_STEPS_NAMES.GUEST_INFO,
        ];
    }

    return navProgressSteps;
};
